module.exports = __webpack_public_path__ + "img/yellow.902faa42.png";